import { createContext, useContext, useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useUser } from './UserContext';

const AuthContext = createContext(null);

export function AuthProvider({ children, initData }) {
  const { deviceId, refreshAuth } = useUser();
  const auth = useAuth(deviceId);

  // Handle auth redirects from URL
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const authSuccess = urlParams.get('auth_success');
    const authError = urlParams.get('auth_error');

    if (authSuccess === 'true') {
      console.log('Auth successful!');
      window.history.replaceState({}, '', window.location.pathname);

      // Refresh user info
      refreshAuth();
    } else if (authError) {
      console.log('Auth error:', authError);
      window.history.replaceState({}, '', window.location.pathname);

      const errorMessages = {
        missing_token: 'Invalid sign-in link. Please request a new one.',
        invalid_token: 'This sign-in link is invalid. Please request a new one.',
        token_used: 'This sign-in link has already been used. Please request a new one.',
        token_expired: 'This sign-in link has expired. Please request a new one.',
        server_error: 'Something went wrong. Please try again.'
      };

      setTimeout(() => {
        alert(errorMessages[authError] || 'Sign-in failed. Please try again.');
      }, 500);
    }
  }, [refreshAuth]);

  const value = {
    ...auth,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuthContext() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
}
